exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-file-name{width:150px;height:32px}.button-file-name{display:block;width:150px;text-align:start;text-wrap:nowrap;overflow:hidden;text-overflow:ellipsis;padding-inline-start:3px}.button-file-name:hover:not(:disabled){box-shadow:inset 0 0 0 1px var(--gray-9)}.button-file-name.spreadsheetEditorFileName:disabled span{color:var(--text-color)}", ""]);

// exports
